var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#3C00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0068 39.396L36.2776 37.5647C35.9089 36.6355 35.3359 35.8022 34.6026 35.123L34.4693 35.0001C33.3151 33.9293 31.7984 33.3335 30.2234 33.3335H19.7776C18.2026 33.3335 16.6859 33.9293 15.5297 34.998L15.3964 35.123C14.663 35.8022 14.0922 36.6355 13.7214 37.5647L12.9922 39.396",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1547 15.515C33.0023 18.3626 33.0023 22.9794 30.1547 25.827C27.3071 28.6745 22.6903 28.6745 19.8427 25.827C16.9951 22.9794 16.9951 18.3626 19.8427 15.515C22.6903 12.6674 27.3071 12.6674 30.1547 15.515",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/UserProfile.7352cb729184c79d1e083a477c4b444e.svg";
export { ForwardRef as ReactComponent };